// extracted by mini-css-extract-plugin
module.exports = {"error":"confirmation-popup_error__hPhAF"};